export const Smalyavichy = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [28.230112241028394, 54.22251890931045],
            [28.218491638930573, 54.21872682604209],
            [28.20934954806455, 54.21555292460391],
            [28.195636412214583, 54.20903731058257],
            [28.186208631036948, 54.20569557110031],
            [28.17563808861337, 54.20285488044783],
            [28.167638758993178, 54.199846876934885],
            [28.159925119684544, 54.19667152511005],
            [28.15392562314321, 54.193495928769664],
            [28.148783196638135, 54.18981861825898],
            [28.145640603211575, 54.18597380695303],
            [28.141355247640888, 54.18112549185747],
            [28.13735558328011, 54.179453527429814],
            [28.135070060788166, 54.18129268458222],
            [28.13364160923055, 54.18580663315555],
            [28.133355918919165, 54.18931714147885],
            [28.132784537397868, 54.19299449659974],
            [28.13021332459448, 54.19533446187427],
            [28.12649935054492, 54.195668731738465],
            [28.122785376495585, 54.19282735119128],
            [28.117928640301898, 54.19165731440705],
            [28.111357762239265, 54.19182446454681],
            [28.10792947850132, 54.19316164133227],
            [28.10650102694376, 54.19466591403511],
            [28.105072575386373, 54.202353561822804],
            [28.105072575386373, 54.205528477056646],
            [28.100787219815686, 54.20903731058257],
            [28.091645128949494, 54.21087515178857],
            [28.08564563240816, 54.21070807869404],
            [28.075360780296137, 54.20920439043476],
            [28.069361282856505, 54.207867732695945],
            [28.058505050121312, 54.20486009412383],
            [28.04822019800929, 54.20201934602699],
            [28.038506726520268, 54.20051534149218],
            [28.030793087211464, 54.198342793326276],
            [28.02793618409669, 54.19433163606038],
            [28.02850756471969, 54.18965146000818],
            [28.03393568153632, 54.185472283532704],
            [28.037935345897267, 54.18313176046507],
            [28.042792082090955, 54.17711266366172],
            [28.03707827496271, 54.17209608030839],
            [28.031650159044375, 54.171092690728926],
            [28.026793422850687, 54.171928850402026],
            [28.020222544788055, 54.173768342188964],
            [28.011937525754774, 54.173266670723365],
            [27.998795769629453, 54.17092545676627],
            [27.99051074969765, 54.165740868053945],
            [27.987368156271316, 54.160722905477485],
            [27.985368324090928, 54.154867846764944],
            [27.97936882665124, 54.15085247045067],
            [27.975940542913293, 54.146836705153646],
            [27.97222656886396, 54.14248585265119],
            [27.97222656886396, 54.1361260922385],
            [27.974512091355905, 54.129765355182315],
            [27.981654350041538, 54.125077871174994],
            [27.98965367876326, 54.12139447587742],
            [27.997367318071895, 54.118380545721266],
            [28.005366647691915, 54.115868769301926],
            [28.009937692675862, 54.112686967992886],
            [28.010223382987476, 54.10883498648633],
            [28.007366479872474, 54.106155136458426],
            [28.00308112520014, 54.102302548069474],
            [28.001081292121285, 54.098784654727865],
            [28.000509911498284, 54.09426121121794],
            [27.99765300838351, 54.09124530763421],
            [27.99051074969765, 54.090742635808965],
            [27.983939872533313, 54.09124530763421],
            [27.977083304159294, 54.09292083639991],
            [27.968512593916103, 54.09493138212338],
            [27.960798955505936, 54.09761195747973],
            [27.950799793705187, 54.101297466284564],
            [27.94222908346211, 54.10649012718386],
            [27.93422975384209, 54.10933743908441],
            [27.927944566090844, 54.10950492193069],
            [27.92165937923795, 54.10950492193069],
            [27.917088333355878, 54.11084476034512],
            [27.91508850117532, 54.1136917737378],
            [27.914802810863875, 54.118380545721266],
            [27.909374694047074, 54.12273393003886],
            [27.904803649063297, 54.12306878734108],
            [27.896518629131663, 54.12306878734108],
            [27.88623377701947, 54.12306878734108],
            [27.88051997078975, 54.12306878734108],
            [27.86909235653343, 54.12474303063374],
            [27.86537838248387, 54.12675203329553],
            [27.861093027811535, 54.13010015513879],
            [27.849094032932214, 54.1327784573906],
            [27.84052332358732, 54.13160672146154],
            [27.836809348639633, 54.12926315017478],
            [27.836523658328247, 54.12306878734108],
            [27.837952109885634, 54.11955265571504],
            [27.84309453639088, 54.116538591089466],
            [27.846522820128655, 54.1136917737378],
            [27.850236795076512, 54.112017083965725],
            [27.849094032932214, 54.10783006302279],
            [27.837380729262634, 54.1073275921575],
            [27.830238471475298, 54.10783006302279],
            [27.813954121923473, 54.1073275921575],
            [27.805097721369066, 54.1029725890607],
            [27.801955127942506, 54.09861712857952],
            [27.799383915139117, 54.09191552726065],
            [27.79771835465459, 54.086333198531975],
            [27.797384082060262, 54.08521284323848],
            [27.79909822482756, 54.07934710643252],
            [27.803383579500064, 54.07515678669063],
            [27.81081152849714, 54.07130131940903],
            [27.821096380609106, 54.06694253340953],
            [27.82995278116391, 54.06342164187191],
            [27.8336667552133, 54.05855896703008],
            [27.8330953745903, 54.05436654894805],
            [27.83109554240974, 54.05084459069411],
            [27.826238806216054, 54.04765780025036],
            [27.82138207092072, 54.04648365795106],
            [27.817382405661476, 54.04178675647171],
            [27.817382405661476, 54.0380959613766],
            [27.819953619363332, 54.03356590142704],
            [27.82709587715067, 54.03104898845049],
            [27.83109554240974, 54.0315523832345],
            [27.840237633275933, 54.03457262448518],
            [27.84309453639088, 54.03759264581703],
            [27.849951104764955, 54.04161900019176],
            [27.85652198192929, 54.044638509640265],
            [27.862235789057536, 54.04447076487037],
            [27.86880666622187, 54.0422900212493],
            [27.869663738054726, 54.03826373187559],
            [27.867949595287428, 54.03457262448518],
            [27.863664240614924, 54.03037778592477],
            [27.85795043348685, 54.024839951142894],
            [27.85652198192929, 54.02114765140442],
            [27.85795043348685, 54.01560858746376],
            [27.85909319473285, 54.012083344913776],
            [27.85537922068329, 54.00872569283348],
            [27.852522317568514, 54.00452824739233],
            [27.853093698191287, 54.000834144679175],
            [27.85795043348685, 53.99713971410796],
            [27.863092859991923, 53.99310905285108],
            [27.86452131154948, 53.989245969122294],
            [27.86509269217248, 53.98403863722501],
            [27.866806834041483, 53.98084672521071],
            [27.87509185397306, 53.97698250393563],
            [27.881377041724136, 53.97631042895614],
            [27.887662228577085, 53.97597438740104],
            [27.89223327445933, 53.97563834313536],
            [27.896518629131663, 53.97328595685832],
            [27.898232771000664, 53.96942103480569],
            [27.897090009754663, 53.965051560303266],
            [27.891090513213328, 53.96101779258379],
            [27.884805325462082, 53.956647437622166],
            [27.887090847954084, 53.95009104509086],
            [27.893661726016717, 53.946896532201606],
            [27.90137536532535, 53.94386992533197],
            [27.908803313424244, 53.93983410858306],
            [27.912802978683317, 53.93411603261944],
            [27.916802643044264, 53.92755609821023],
            [27.918516784913265, 53.918976166162565],
            [27.920230927680564, 53.913086957290716],
            [27.926516114533456, 53.90517728463357],
            [27.93051577979253, 53.89928612963189],
            [27.925087662975898, 53.89490930513796],
            [27.918516784913265, 53.893730851123735],
            [27.91051745619137, 53.89305743390929],
            [27.904517958751683, 53.89171056692601],
            [27.897090009754663, 53.8893534447285],
            [27.896518629131663, 53.882954872412995],
            [27.898232771000664, 53.879586809646526],
            [27.902518126571294, 53.87588162669033],
            [27.90337519750574, 53.87217611541422],
            [27.902518126571294, 53.867796452134144],
            [27.898804151623665, 53.864595638420326],
            [27.889947751967327, 53.862405467233714],
            [27.87937720864545, 53.85920424102801],
            [27.877948757087893, 53.85516023744958],
            [27.879948590166748, 53.84959909386322],
            [27.88366256421608, 53.845891254111734],
            [27.890804822901714, 53.842183085930685],
            [27.89737570006605, 53.839317458698986],
            [27.901089675013907, 53.835945880923134],
            [27.90080398470235, 53.831731027624926],
            [27.898232771000664, 53.82802160531514],
            [27.894518796951274, 53.8231314105318],
            [27.893090345393716, 53.81958987904363],
            [27.893947416328274, 53.81537337930405],
            [27.89794708068905, 53.812337236646954],
            [27.906803481243685, 53.81098776954872],
            [27.92194506954951, 53.81098776954872],
            [27.933944063530532, 53.81065039598565],
            [27.943086154396553, 53.80930087458046],
            [27.953085316197132, 53.80491462942797],
            [27.959084812738638, 53.80170900659857],
            [27.96679845204727, 53.7986718741538],
            [27.973369330109904, 53.79479077383911],
            [27.975654852601906, 53.79074054765317],
            [27.975404060161736, 53.78718472414556],
            [27.983654182221926, 53.78702749621726],
            [27.987082465959872, 53.78550842612498],
            [27.991653511841946, 53.78365171020778],
            [27.998510079317896, 53.78719627838808],
            [27.997367318071895, 53.79512827556539],
            [27.994796105268506, 53.8006966532044],
            [27.997367318071895, 53.804745918546985],
            [28.006509408938086, 53.80491462942797],
            [28.01736564167311, 53.80137155835962],
            [28.018794093230497, 53.79698448359642],
            [28.02165099724374, 53.792259428303566],
            [28.024507900358742, 53.78888406274962],
            [28.02850756471969, 53.78668992983887],
            [28.033649991224763, 53.78314531887963],
            [28.034221371847764, 53.778418704575586],
            [28.035364133093708, 53.774029228826464],
            [28.03593551371671, 53.77099009243983],
            [28.039935178077656, 53.76896387874007],
            [28.045934675517344, 53.7691327335728],
            [28.051934172956976, 53.77115893912281],
            [28.061933334757555, 53.77048354778509],
            [28.063647476626556, 53.769301587726375],
            [28.064504547561114, 53.76592437561516],
            [28.065361618495558, 53.762715771944386],
            [28.067075760364503, 53.76204024530375],
            [28.072789567492748, 53.7622091279826],
            [28.07764630278791, 53.763560164963394],
            [28.08078889621447, 53.764404541002534],
            [28.085931322719716, 53.764404541002534],
            [28.090788058015107, 53.764235667153],
            [28.10421550445193, 53.76170247790816],
            [28.10907223974732, 53.759675816480865],
            [28.112500523485096, 53.758324653994066],
            [28.12021416279373, 53.75494655891822],
            [28.12507089898753, 53.75443982122289],
            [28.13078470521731, 53.75612892310045],
            [28.135070060788166, 53.75866244855831],
            [28.138498344525942, 53.763560164963394],
            [28.142212318575275, 53.76980814611221],
            [28.144783532277188, 53.77352272137574],
            [28.148783196638135, 53.7752110557762],
            [28.158210977815713, 53.77554871450707],
            [28.163924784943788, 53.77352272137574],
            [28.17078135241968, 53.77250968813763],
            [28.175923778924755, 53.77301620781276],
            [28.176495159547926, 53.77639284944979],
            [28.17563808861337, 53.78483326620693],
            [28.17478101767881, 53.79192190402307],
            [28.172209803977125, 53.79597201667275],
            [28.16449616556679, 53.801034107405144],
            [28.162496332488104, 53.808963487440735],
            [28.16563892681279, 53.814698700060376],
            [28.167924449304735, 53.82110771490579],
            [28.167638758993178, 53.82819022252227],
            [28.167067378370348, 53.838643164966186],
            [28.167067378370348, 53.84353154906205],
            [28.170209971796737, 53.847913752582485],
            [28.173923946744367, 53.85044173879305],
            [28.179637752974315, 53.85246401741409],
            [28.18420879885656, 53.853980662259175],
            [28.18906553415195, 53.86088912770742],
            [28.188779843840337, 53.866280307467264],
            [28.18849415352895, 53.87672374243459],
            [28.189922605086338, 53.880597256965416],
            [28.19477934127997, 53.88766970500507],
            [28.19820762501797, 53.88918507380828],
            [28.201921599067475, 53.89002692162694],
            [28.206778335261163, 53.888343209033394],
            [28.211063689933496, 53.884470412140104],
            [28.21563473581574, 53.881607679865056],
            [28.22049147111113, 53.87840792304803],
            [28.227062349173764, 53.874702636157394],
            [28.23106201353471, 53.871839234519996],
            [28.233347536026486, 53.8698178921714],
            [28.238204272220344, 53.86712261707953],
            [28.242489626892734, 53.86880718436396],
            [28.24506084059442, 53.87268143219711],
            [28.246774982463364, 53.87672374243459],
            [28.248489124332366, 53.8812708749449],
            [28.25077464682431, 53.88514396824627],
            [28.256774144264, 53.88817483404375],
            [28.26534485450719, 53.890868753019106],
            [28.271630041359913, 53.89238400584344],
            [28.28162920316055, 53.89490930513796],
            [28.28820008122318, 53.89692943523403],
            [28.292199745584128, 53.8997911182808],
            [28.299056313958147, 53.904167431436804],
            [28.30305597831915, 53.907196917790486],
            [28.305912882332393, 53.908711579105955],
            [28.31048392731634, 53.911235891692456],
            [28.313912211054287, 53.91190901594854],
            [28.318197566624974, 53.9107310413807],
            [28.32333999223175, 53.90988961063266],
            [28.328196728425553, 53.911235891692456],
            [28.33076794122894, 53.915442740829235],
            [28.33333915403233, 53.918134901537655],
            [28.338481580537575, 53.92082688920067],
            [28.34790936171521, 53.92183633962719],
            [28.35962266538479, 53.918134901537655],
            [28.36476509099151, 53.914601405010615],
            [28.366193543447423, 53.91089932549602],
            [28.36819337562781, 53.908543286175416],
            [28.373050110923145, 53.905345591126434],
            [28.378478227739777, 53.90450405188153],
            [28.383049272723724, 53.9050089774629],
            [28.388477389540412, 53.905513896941045],
            [28.393334124835917, 53.90517728463357],
            [28.40104776414455, 53.902147651275016],
            [28.408475713141627, 53.9008010772684],
            [28.416189351551907, 53.899959446474156],
            [28.432759391415175, 53.89928612963189],
            [28.451043573147388, 53.897434452366326],
            [28.46447101868597, 53.89709777495631],
            [28.476184322355323, 53.89676109483338],
            [28.485612103532958, 53.89760279005412],
            [28.49532557502215, 53.899117798725854],
            [28.50218214339617, 53.9008010772684],
            [28.50761025931456, 53.904840669613804],
            [28.515323898623194, 53.909384744046974],
            [28.51846649294805, 53.914769673530486],
            [28.521894776685997, 53.920322154305154],
            [28.52360891855477, 53.924864544460775],
            [28.52303753793177, 53.93192950203331],
            [28.51389544706575, 53.935293347504455],
            [28.507324569003117, 53.936302448110894],
            [28.49761109841222, 53.938320576112346],
            [28.493897123464592, 53.94185206576236],
            [28.49218298159576, 53.9465602534533],
            [28.493897123464592, 53.95076354347049],
            [28.50075369183878, 53.95395776017017],
            [28.507895950524414, 53.95530262031963],
            [28.515895279246138, 53.959673116775434],
            [28.518180802636437, 53.96303472550102],
            [28.519037873570994, 53.96774052157616],
            [28.520752015439996, 53.9753022961595],
            [28.52212226288634, 53.976489855027125],
            [28.512752685819805, 53.97832662137074],
            [28.503039214330784, 53.98185472384955],
            [28.498753859658393, 53.98454260097418],
            [28.49732540720254, 53.98991783542283],
            [28.498753859658393, 53.99478854246212],
            [28.502467833707783, 53.998819041663694],
            [28.505039046511172, 54.001505824007666],
            [28.50532473682273, 54.007214661243495],
            [28.498468169346836, 54.010908197688366],
            [28.489897459103815, 54.01174759195021],
            [28.481898129483568, 54.010908197688366],
            [28.47732708449962, 54.00889358184571],
            [28.473898799863548, 54.00855780314396],
            [28.466470850866358, 54.010908197688366],
            [28.460471354324966, 54.01426567314019],
            [28.45532892781972, 54.01795858375732],
            [28.4461868369537, 54.022826010388656],
            [28.436759055776122, 54.022826010388656],
            [28.42933110767723, 54.026518160611886],
            [28.431616630169174, 54.03172018014152],
            [28.437616127608806, 54.03507597660911],
            [28.439615959789364, 54.03759264581703],
            [28.439615959789364, 54.04346428203303],
            [28.431330939857787, 54.04782553215637],
            [28.42133177805715, 54.052354038233545],
            [28.417046423384818, 54.0560435667424],
            [28.417332113696204, 54.05956508428625],
            [28.42276022961454, 54.0624156175046],
            [28.430759559234787, 54.06509829411914],
            [28.43618767515312, 54.068954337407376],
            [28.43247370110356, 54.07264239211702],
            [28.426188513352542, 54.076162502407215],
            [28.425617132729542, 54.08135830993473],
            [28.42733127549684, 54.08688861562047],
            [28.428188346431227, 54.089737273887806],
            [28.42133177805715, 54.0945962980241],
            [28.41418951937152, 54.09610415515658],
            [28.41104692594496, 54.101297466284564],
            [28.410475545322015, 54.103475112699584],
            [28.40219052539055, 54.10799755195819],
            [28.389620150786413, 54.109672404100365],
            [28.382192201789337, 54.106155136458426],
            [28.38133513085478, 54.10146498160708],
            [28.38247789210078, 54.09660676202077],
            [28.385049104904112, 54.09124530763421],
            [28.38733462829458, 54.0863858910115],
            [28.390762912032358, 54.080352720102155],
            [28.39190567327836, 54.07565964785812],
            [28.389620150786413, 54.071971861177815],
            [28.385620485527113, 54.070463126968775],
            [28.376192705248002, 54.06945727370447],
            [28.370478898119757, 54.068954337407376],
            [28.366193543447423, 54.063924644653525],
            [28.361908187876736, 54.062583289836994],
            [28.350194884207156, 54.06140956929562],
            [28.341052793340964, 54.06140956929562],
            [28.32962517998294, 54.062080270809304],
            [28.31991170849375, 54.062583289836994],
            [28.31362652074273, 54.06560127659367],
            [28.30619857264378, 54.07029548645022],
            [28.29991338489276, 54.074653919958735],
            [28.292485435895514, 54.07917950178552],
            [28.29019991340374, 54.085380423522],
            [28.29019991340374, 54.089402147833766],
            [28.287343010288794, 54.09325593455958],
            [28.284200415963937, 54.095936618181724],
            [28.279915061291547, 54.09978979793544],
            [28.27848660973416, 54.1044801417093],
            [28.280486441914547, 54.1069926081978],
            [28.29077129402657, 54.10900247136226],
            [28.297342172089373, 54.109672404100365],
            [28.304770120188095, 54.10866750093379],
            [28.309626856381783, 54.1053176478045],
            [28.315626353821585, 54.1044801417093],
            [28.32362568254331, 54.10314009761686],
            [28.33076794122894, 54.10314009761686],
            [28.337053128980187, 54.10112995028561],
            [28.345623839223208, 54.101297466284564],
            [28.351051955141543, 54.103810125075825],
            [28.360765426630735, 54.10766257341089],
            [28.365336471614512, 54.109839885593544],
            [28.3701932078082, 54.11285443730827],
            [28.373907181857703, 54.116538591089466],
            [28.382192201789337, 54.12273393003886],
            [28.387620318606025, 54.1260823765644],
            [28.39247705390136, 54.13043495238969],
            [28.39561964732775, 54.133615391334615],
            [28.396476719160603, 54.13830190947067],
            [28.394476886081748, 54.141649097935726],
            [28.38933446047497, 54.144996015353456],
            [28.383049272723724, 54.14566536637551],
            [28.374478562480704, 54.14666937314638],
            [28.363050949122567, 54.14733869711756],
            [28.35847990413879, 54.14784068299531],
            [28.34790936171521, 54.15085247045067],
            [28.345623839223208, 54.15302751454465],
            [28.345909529534595, 54.158213695726374],
            [28.347052290780766, 54.1640682811244],
            [28.350194884207156, 54.16891859595256],
            [28.35305178732193, 54.17259776597115],
            [28.354480238879546, 54.17661103275867],
            [28.353337477633545, 54.18145987663087],
            [28.350766264830156, 54.18463639764633],
            [28.34448107707891, 54.18881565861528],
            [28.33533898621289, 54.18914998120022],
            [28.32476844378931, 54.18814700533409],
            [28.32105446973992, 54.18580663315555],
            [28.313340830431116, 54.18313176046507],
            [28.30448442987671, 54.18430203856013],
            [28.29762786240076, 54.187812674112365],
            [28.29562803022037, 54.19332878538893],
            [28.301056146138762, 54.19817566954606],
            [28.305341501709393, 54.20168512752787],
            [28.31476928198873, 54.20502719087074],
            [28.32362568254331, 54.207199387607886],
            [28.328482418736996, 54.211710507124224],
            [28.327339657490995, 54.21622113454123],
            [28.31848325693636, 54.217891612609435],
            [28.313912211054287, 54.217891612609435],
            [28.301056146138762, 54.21488470385492],
            [28.29505664959737, 54.2127129117527],
            [28.28505748779679, 54.21120929595014],
            [28.27477263568477, 54.21120929595014],
            [28.26391640205128, 54.21221171274203],
            [28.2533458596277, 54.21421647229454],
            [28.24106117533512, 54.217557521981405],
            [28.2324904650921, 54.22073126935902],
            [28.230112241028394, 54.22251890931045],
          ],
        ],
      },
      properties: {
        shapeName: "Smalyavichy",
        shapeISO: "",
        shapeID: "67162791B46914171064537",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
